import { MotionDiv } from '@/components/element/MotionDiv';
import { useQuotationTasks } from '@/hooks/api/1440_quotation_tasks';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export const QuotationTasks = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { data: tasks } = useQuotationTasks({
    identifier: _w_!.identifier,
    sales_order_id: _so_!.id,
    archived: true,
    page: 1,
    per: 1000,
  });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">見積申請タスク一覧</h6>
        </div>
        <Link
          to={`/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}/quotation_tasks/new`}
          className="btn bg-gradient-primary btn-icon flex-shrink-0"
        >
          <i className="fas fa-plus"></i>新規タスク作成
        </Link>
      </div>
      <div className="card-body pt-0">
        {tasks?.quotation_tasks.map((d, i) => (
          <Fragment key={`qa-${d.id}`}>
            {i != 0 && <hr className="horizontal dark" />}

            <Link
              to={`/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}/quotation_tasks/${d.id}`}
              className="d-flex align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center">
                <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0">
                  <i className="fas fa-receipt text-white"></i>
                </div>
                <div className="ms-2">
                  <div className="font-weight-bold px-0 text-sm text-dark mb-1">{d.name}</div>
                  <div className="text-muted font-weight-bold text-xs">{d.quotation_task_phase.label}</div>
                </div>
              </div>
              <i className="fas fa-angle-right text-muted opacity-3 flex-shrink-0 ms-2"></i>
            </Link>
          </Fragment>
        ))}
      </div>
    </MotionDiv>
  );
};
